import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  // Icon,
  Grid,
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TextField,
  Divider,
} from "@mui/material";

import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";

// import { useAuthUser } from "react-auth-kit";

import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";

function AccountProfile() {
  const title = "My Account";
  usePageTitle(title);

  //   const auth = useAuthUser();
  //   const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);

  const [accountInfo, setAccountInfo] = useState(null);
  const [logo, setLogo] = useState(null);
  const [icon, setIcon] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("portal/accounts/fetch.json")
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setAccountInfo(result.data.data.account);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function fileSelected(e, type) {
    e.persist();
    const fileTypes = ["jpeg", "jpg", "png"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("File type not supported");
      setOpen(true);
      return;
    }

    if (type === "logo") {
      setLogo(e.target.files[0]);
    } else {
      setIcon(e.target.files[0]);
    }
  }

  async function uploadMedia() {
    if (logo === null && icon === null) {
      return;
    }

    const formData = new FormData();
    if (logo !== null) {
      formData.append("logo", logo);
    }
    if (icon !== null) {
      formData.append("icon", icon);
    }

    console.log(formData);
    setShowLoading(true);
    await axios
      .post("portal/accounts/upload/logos.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pt={1.5} pb={3} mb={3}>
        {accountInfo === null ? (
          <> </>
        ) : (
          <MDBox>
            <Card sx={{ width: "100%", marginTop: "10px" }}>
              <MDBox mt={1}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Business Information
                  </MDTypography>
                </MDBox>
                <TableContainer component={Paper}>
                  <Table aria-label="account information">
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Business Name
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.title}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Email Address
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.email_address}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Phone Number
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.phone_number}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Business Address
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.physical_address}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Business Industry
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.industry}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Business Type
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.business_type}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Currency
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.currency}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <MDTypography variant="h6" fontWeight="regular">
                            Date Created
                          </MDTypography>
                        </TableCell>
                        <TableCell align="right">
                          <MDTypography variant="h6" fontWeight="light">
                            {accountInfo.created}
                          </MDTypography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </MDBox>
            </Card>

            <MDBox mt={5}>
              <Card sx={{ width: "100%", marginTop: "10px" }}>
                <MDBox mt={1} p={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="regular" textTransform="capitalize">
                          Brand Logo
                        </MDTypography>
                        <MDBox mt={1}>
                          {accountInfo.logo && (
                            <img
                              width="128px"
                              src={`${AppConfig.api_media_url}${accountInfo.logo}`}
                              alt=""
                            />
                          )}
                        </MDBox>
                        <MDBox mb={1}>
                          <TextField
                            accept=".png,.jpg,.jpeg"
                            type="file"
                            name="logo"
                            id="logo"
                            // onChange={handleFileInputChange}
                            onChange={(e) => fileSelected(e, "logo")}
                          />
                        </MDBox>
                        <MDButton
                          size="small"
                          color="dark"
                          variant="contained"
                          onClick={() => {
                            uploadMedia();
                          }}
                        >
                          Upload Logo
                        </MDButton>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="regular" textTransform="capitalize">
                          Brand Icon
                        </MDTypography>
                        <MDBox mt={1}>
                          {accountInfo.icon && (
                            <img
                              width="64px"
                              src={`${AppConfig.api_media_url}${accountInfo.icon}`}
                              alt=""
                            />
                          )}
                        </MDBox>
                        <MDBox mb={1}>
                          <TextField
                            accept=".png,.jpg,.jpeg"
                            type="file"
                            name="icon"
                            id="icon"
                            // onChange={handleFileInputChange}
                            onChange={(e) => fileSelected(e, "icon")}
                          />
                        </MDBox>
                        <MDButton
                          size="small"
                          color="dark"
                          variant="contained"
                          onClick={() => {
                            uploadMedia();
                          }}
                        >
                          Upload Icon
                        </MDButton>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AccountProfile;
